module.exports = __webpack_public_path__ + "img/baking-ingredients2.70ef4ea5.jpeg";